import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-583a3c75"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tenant-report-content d-flex" }
const _hoisted_2 = { class: "history" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "history-header d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Rental History")
], -1))
const _hoisted_4 = { class: "history-item d-flex align-items-center" }
const _hoisted_5 = { class: "history-details d-flex align-items-center justify-content-between w-100" }
const _hoisted_6 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_7 = {
  class: "d-flex align-items-center",
  style: {"margin-bottom":"10px"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-map-marker-alt icon d-inline-block" }, null, -1))
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt icon d-inline-block" }, null, -1))
const _hoisted_12 = { class: "text" }
const _hoisted_13 = {
  class: "d-flex align-items-center",
  style: {"margin-left":"auto"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-star text-warning me-1 star" }, null, -1))
const _hoisted_15 = { class: "rating" }
const _hoisted_16 = { class: "submitted" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Submitted by:", -1))
const _hoisted_18 = { class: "d-flex align-center profile" }
const _hoisted_19 = { class: "info d-flex align-items-center w-100" }
const _hoisted_20 = { class: "details" }
const _hoisted_21 = { class: "name" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "position" }, "Agent")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"auto"} }, null, -1))
const _hoisted_24 = { class: "other-details" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-building icon" }, null, -1))
const _hoisted_26 = { class: "text" }
const _hoisted_27 = { class: "other-details" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-hashtag icon" }, null, -1))
const _hoisted_29 = { class: "text" }
const _hoisted_30 = { class: "other-details" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-hashtag icon" }, null, -1))
const _hoisted_32 = { class: "text" }
const _hoisted_33 = { class: "other-details" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-globe icon" }, null, -1))
const _hoisted_35 = { class: "text" }
const _hoisted_36 = { class: "other-details" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-map-marker-alt icon" }, null, -1))
const _hoisted_38 = { class: "text" }
const _hoisted_39 = { class: "other-details" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone-alt icon" }, null, -1))
const _hoisted_41 = { class: "text" }
const _hoisted_42 = { class: "other-details" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-envelope icon" }, null, -1))
const _hoisted_44 = { class: "text" }
const _hoisted_45 = { class: "overview" }
const _hoisted_46 = { class: "w-100 view-tenant-review-report" }
const _hoisted_47 = { class: "row details" }
const _hoisted_48 = { class: "col-lg-12 pb-5" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title d-block" }, "Location", -1))
const _hoisted_50 = { class: "sub-text d-block" }
const _hoisted_51 = { class: "col-lg-4 pb-5" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title d-block" }, "Move In Date", -1))
const _hoisted_53 = { class: "sub-text d-block" }
const _hoisted_54 = { class: "col-lg-4 pb-5" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title d-block" }, "Move Out Date", -1))
const _hoisted_56 = { class: "sub-text d-block" }
const _hoisted_57 = { class: "col-lg-4" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title d-block" }, "Date Submitted", -1))
const _hoisted_59 = { class: "sub-text d-block" }
const _hoisted_60 = { class: "ratings-overview d-flex pt-5" }
const _hoisted_61 = { class: "col-lg-6 pb-5" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Overall Rating", -1))
const _hoisted_63 = { class: "col-lg-6 pb-5" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title d-block" }, "Rent Per Week", -1))
const _hoisted_65 = { class: "sub-text d-block" }
const _hoisted_66 = { class: "ratings" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Report", -1))
const _hoisted_68 = { class: "text d-flex" }
const _hoisted_69 = { class: "me-3" }
const _hoisted_70 = { class: "d-block" }
const _hoisted_71 = {
  key: 0,
  style: {"margin-left":"15px"}
}
const _hoisted_72 = {
  key: 1,
  style: {"margin-left":"15px"}
}
const _hoisted_73 = {
  key: 2,
  class: "text-answer w-100"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_BusinessLogo = _resolveComponent("BusinessLogo")!
  const _component_GoogleMap = _resolveComponent("GoogleMap")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.tenantAddress), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.dateFormat(_ctx.info?.move_in_date)) + " - " + _toDisplayString(_ctx.dateFormat(_ctx.info?.move_out_date)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.info?.average_rating), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_Avatar, {
              width: "64px",
              height: "64px",
              src: _ctx.agentAvatar
            }, null, 8, ["src"]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.info?.user?.first_name) + " " + _toDisplayString(_ctx.info?.user?.last_name), 1),
              _hoisted_22
            ]),
            _hoisted_23,
            (_ctx.hasLogo)
              ? (_openBlock(), _createBlock(_component_BusinessLogo, {
                  key: 0,
                  imageSrc: _ctx.getBusinessLogo,
                  fill: "scale-down",
                  height: "30px"
                }, null, 8, ["imageSrc"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.info?.user?.business_name || '"No Business Name"'), 1)
        ]),
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.formattedAbn || '"No ABN"'), 1)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.formattedAcn || '"No ACN"'), 1)
        ]),
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.info?.user?.business_website || '"No Website"'), 1)
        ]),
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.address || '"No Address"'), 1)
        ]),
        _createElementVNode("div", _hoisted_39, [
          _hoisted_40,
          _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$filters.formatPhone(_ctx.info?.user?.business_phone_number) ||
            '"No Mobile Number"'), 1)
        ]),
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.info?.user?.business_email_address || '"No Email Address"'), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("div", {
        class: "overview-header d-flex align-items-center justify-content-center",
        style: _normalizeStyle(`background:${_ctx.headerColor}!important`)
      }, [
        (_ctx.hasLogo)
          ? (_openBlock(), _createBlock(_component_BusinessLogo, {
              key: 0,
              imageSrc: _ctx.getBusinessLogo,
              fill: "scale-down",
              height: "23px"
            }, null, 8, ["imageSrc"]))
          : _createCommentVNode("", true)
      ], 4),
      _createVNode(_component_GoogleMap, {
        disableUI: true,
        zoom: 14,
        mapType: "roadmap",
        center: { lat: -33.867, lng: 151.195 },
        draggable: false,
        query: _ctx.tenantAddress,
        height: "150px",
        ref: "map"
      }, null, 8, ["center", "query"]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _hoisted_49,
            _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.tenantAddress), 1)
          ]),
          _createElementVNode("div", _hoisted_51, [
            _hoisted_52,
            _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.dateFormat(_ctx.info?.move_in_date)), 1)
          ]),
          _createElementVNode("div", _hoisted_54, [
            _hoisted_55,
            _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.dateFormat(_ctx.info?.move_out_date)), 1)
          ]),
          _createElementVNode("div", _hoisted_57, [
            _hoisted_58,
            _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.dateFormat(_ctx.info?.date_created)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _hoisted_62,
            _createVNode(_component_el_rate, {
              class: "review-ans-avrg",
              "model-value": _ctx.info?.average_rating,
              disabled: "",
              "allow-half": ""
            }, null, 8, ["model-value"])
          ]),
          _createElementVNode("div", _hoisted_63, [
            _hoisted_64,
            _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.info?.rent_per_week), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_66, [
          _hoisted_67,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info?.review_answers, (answer, key) => {
            return (_openBlock(), _createElementBlock("div", {
              key: key,
              class: _normalizeClass(["rating-item w-100 d-flex justify-content-between flex-wrap", { 'html2pdf__page-break': key == 3 }])
            }, [
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, _toDisplayString(key + 1) + ".)", 1),
                _createElementVNode("span", _hoisted_70, _toDisplayString(answer.question), 1)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["answer", { 'is-text': answer.type == 'textbox' }])
              }, [
                (answer.type === 'rating')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                      _createVNode(_component_el_form_item, {
                        prop: answer.id
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_rate, {
                            disabled: "",
                            size: "small",
                            class: "rating-size",
                            modelValue: answer.answer,
                            "onUpdate:modelValue": ($event: any) => ((answer.answer) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["prop"])
                    ]))
                  : (answer.type === 'radio')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", _ctx.getColor(answer.answer)])
                        }, _toDisplayString(answer?.answer), 3)
                      ]))
                    : (answer.type === 'textbox')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, _toDisplayString(answer.answer), 1))
                      : _createCommentVNode("", true)
              ], 2)
            ], 2))
          }), 128))
        ])
      ])
    ])
  ]))
}